import React from 'react'
import styled from 'styled-components'
import Devices from './Components/Devices'

/** الأجهزة المسجّلة — the design's devices page inside the standard shell. */
const Settings = () => {
	return (
		<Page>
			<Devices />
		</Page>
	)
}

/* Design shell: 512px centred column on mobile, 960px on desktop. */
const Page = styled.div`
	width: 100%;
	max-width: 512px;
	margin: 0 auto;
	background: var(--surface-page);
	padding: 16px 16px 40px;
	display: flex;
	flex-direction: column;
	gap: 12px;
	@media (min-width: 1024px) {
		max-width: 960px;
		padding: 16px 24px 48px;
	}
`

export default Settings
